import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { t } from '../../../translation/translation';
import Collapsible from '../../common/Collapsible';
import './style.css'

export const SectionSupportRules = () => {
    return (
        <div className='section-support-rules-container section'>
            <Collapsible
                title={t(TEXT_KEYS.SUPPORT_RULES_TITLE_1)}
            >
                <ol style={{ lineHeight: 1.6 }}>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_1)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_2)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_3)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_4)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_5)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_1_6)}</li>
                </ol>
            </Collapsible>
            <Collapsible
                title={t(TEXT_KEYS.SUPPORT_RULES_TITLE_2)}
            >
                <ol style={{ lineHeight: 1.6 }}>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_1)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_2)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_3)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_4)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_5)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_6)}</li>
                    <li>{t(TEXT_KEYS.SUPPORT_RULES_2_7)}</li>
                </ol>
            </Collapsible>
        </div>
    );
};